// Excel-style TRUNC to 2 decimals (no rounding).
// toFixed(8) first removes float noise, e.g. 0.29 * 100 = 28.999999999999996
export function truncateTwoDecimals(number) {
	return Math.trunc(Number(((Number(number) || 0) * 100).toFixed(8))) / 100;
}

// Truncated value as a string with 2 decimals, for display
export function formatTwoDecimals(number) {
	return truncateTwoDecimals(number).toFixed(2);
}

// Subtotal of one cog for one yard (price * quantity), truncated to 2 decimals
export function getCogSubtotal(price, quantity) {
	return truncateTwoDecimals((Number(price) || 0) * (Number(quantity) || 0));
}

// Cost of one cog item of an aggregate for one yard (price * quantity)
export function getCogCost(item) {
	if (!item || !item.cog) return 0;
	return getCogSubtotal(item.cog.unitPriceConversion, item.quantity);
}

// Total cogs cost of an aggregate for one yard (sum of the truncated subtotals)
export function getAggregateCogsCost(aggregate) {
	if (!aggregate || !aggregate.cogs) return 0;
	return truncateTwoDecimals(
		aggregate.cogs.reduce((total, item) => total + getCogCost(item), 0),
	);
}

// Total of the cog rows of an aggregate form, where each row `cog` value is
// "id unit price" (sum of the truncated subtotals)
export function getCogRowsTotal(rows = []) {
	return truncateTwoDecimals(
		rows.reduce(
			(total, row) =>
				row?.cog
					? total + getCogSubtotal(row.cog.split(" ")[2], row.quantity)
					: total,
			0,
		),
	);
}
